import React, { Component }                                       from "react"
import PropTypes                                                  from "prop-types"
import { observer }                                               from "mobx-react"
import { Col, Row }                                               from "elemental-react16"
import { Label, Icon, Breadcrumb, Card, Button, Container, Grid } from "semantic-ui-react"
import { Link, useHistory  }                                                   from "react-router-dom"
import _                                                          from "lodash"
import MediaQuery                                                 from "react-responsive"
import queryString                                                from "qs"
import NavigationSidebar                                          from "components/Navigation/NavigationSidebar"
import Filter                                                     from "components/Filter/Filter"
import ProductCard                                                from "components/Product/ProductCard"
import historyStore                                               from "stores/historyStore"
import WordPress                                                  from "WordPress"
import CategoryShortcuts                                          from "plugin/CategoryShortcuts/CategoryShortcuts"
import ProductListItem from "components/Product/ProductListItem"
import productStore  from "stores/productStore"
import categoryStore from "stores/categoryStore"
import cmsStore      from "stores/cmsStore"

import shop            from "shop/shop"
import MobileTitleBar  from "components/MobileTitleBar"
import { SEOCategory } from "components/SEO";

@observer
export default class CollectionPage extends Component {
  
  recentlyChangedQuery = false
  
  constructor( props ) {
    super( props )
    this.state = {
      showFilterBar: false,
      showSortBar: false,
      path: [],
      products: [],
      ready: false,
      filter: {
        total: 24,
        pageSize: shop.config.pageSize,
        currentPage: 1,
      },
      query: {
        page: props.location.page || 1,
        count: props.location.count || shop.config.pageSize,
        total: 48,
        limit: 3
      },
      listview: ''
    }
  }
  
  componentWillUnmount() {
    categoryStore.hideFilter()
  }
  
  componentDidMount() {
    categoryStore.showFilter()
    historyStore.reset()
    this.loadFrom( this.props )
  }
  
  componentWillReceiveProps( props ) {
    this.loadFrom( props )
  }
  
  toggleSortBar = () => {
    this.setState( { showSortBar: !this.state.showSortBar } )
  }
  
  toggleFilterBar = () => {
    this.setState( { showFilterBar: !this.state.showFilterBar } )
  }
  
  getCategoryId( props = this.props ) {
    return decodeURIComponent(props.match.params.id || props.match.params.parent)
  }
  
  loadFrom( props ) {
    let id = this.getCategoryId( props )
    let query = queryString.parse( props.location.search, { ignoreQueryPrefix: true } )
    query.count = query.count || this.state.query.count
    query.page = query.page || 1
    this.load( id, query )
  }
  
  
  async fetchCategoryPage( collectionId ) {
    console.log( "FETCH CATEGORY PAGE", collectionId )
    let result = []
    try {
       result = await shop.fetch( `/wp/wp-json/wp/v2/shop-category?slug=${collectionId}` )
                             .catch( err => err )
    }
    catch (err) {
      console.error( "Error on fetching shop-category", err )
      result = false
    }
    
    
    if ( result.length > 0 ) {
      this.setState( { categoryPage: result[ 0 ] } )
    } else {
      this.setState( { categoryPage: 0 } )
    }
  }
  
  load( id, query ) {
    console.log( "search", { query } )
    if ( this.recentlyChangedQuery ) {
      this.recentlyChangedQuery = false
      return
    }
    this.fetchCategoryPage( id )
    
    
    query.sort = query.sort || shop.config.standards.SORT || "des"
    query.dir = query.dir || shop.config.standards.DIR || "desc"
    this.current_id = id
    let path = shop.getCategoryPath( id )
    
    historyStore.fromPath( path )
    this.setState( { path } )
    
    let category = _.first( _.filter( [...shop.categoriesById.entries()], (( [cat_id, cat] ) => cat.map_id === id) ) )
    if ( category ) category = category[ 1 ]
    
    let additionalFilters = []
    
    if ( cmsStore.config.plugin.hideVariants ) {
      // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
      let noVariants = {
        op: "equals",
        field: "type",
        value: "1"
      }
      const singleItems = { "field": "mainArticle", "op": "equals", "value": "" }
      let combinedFilter = [{ "or": [singleItems, noVariants] }]
      additionalFilters = additionalFilters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
    }
    if ( query.field && query.field !== "false" && query.fieldValue ) {
      let filter = new shop.Filter()
      filter
        .searchField( true )
        .field( query.field )
      
      additionalFilters.push( filter.query( query.fieldValue ) )
    }
    
    productStore.fromCategory( id, query, additionalFilters )
                .then( res => {
                  let { products } = res
                  if ( products.length === 0 ) {
                    if ( products.length === 0 && shop.config.collections.showProductsFromSubCategories ) {
                      // get products from all child categories
                      const ids = _.flatten( category && category.children.map( mapChildren ) )
                      if ( ids.length > 0 ) {
                        return productStore.fromCategory( ids, query, additionalFilters )
                      }
                    }
                  }
                } )
  }
  
  onChangeFilter = ( filter ) => {
    this.updateQuery( filter )
  }
  
  removeFieldFilter = () => {
    let id = this.props.match.params.id || this.props.match.params.parent
    let query = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    delete query.field
    delete query.fieldValue
    let strQuery = queryString.stringify( query )
    this.props.history.replace( `${this.props.location.pathname}?${strQuery}` )
    this.load( id, query )
  }
  
  updateQuery( { page, sort, pageSize, brand, design, dir } ) {
    this.recentlyChangedQuery = true
    let id = this.props.match.params.id || this.props.match.params.parent
    let query = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    query.page = page || query.page
    query.dir = dir || query.dir
    query.count = pageSize || query.count
    query.sort = sort || query.sort
    query.brand = brand
    query.design = design
    
    let pathname = `/collection/${id}`
    if ( this.props.match.params.parent ) {
      pathname = `/collection/${this.props.match.params.parent}/${id}`
    }
    
    let strQuery = queryString.stringify( query )
    this.props.history.replace( `${this.props.location.pathname}?${strQuery}` )
    this.load( id, query )
  }
  
  render() {
    let { path, showFilterBar, showSortBar, categoryPage,listview } = this.state
    const showAnyBar = showFilterBar || showSortBar
    let id = this.getCategoryId( this.props )
    const ready = !productStore.loading
    const loading = !ready
    const query = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    const { field, fieldValue } = query
    const { match } = this.props
    const { response } = productStore
    let showPagination = true
    console.log("Übernommen?",listview)
    if(query.view && listview != query.view){
      console.log("QUERY: ",query.view)
      this.setState({listview: query.view})
      console.log("statelistview: ", listview)
    }
    // if ( response && response.products.length > 1 || field ) {
    //   showPagination = true
    // }
    
    if ( response && response.products.length > 0 ) {
      categoryStore.showFilter()
    } else {
      categoryStore.hideFilter()
    }
    
    const category = categoryStore.categoriesById.get( id ) || {}
    
    if ( !category ) return null
    
    /*let products = response && response.products.map( ( product, key ) => {
      return <ProductCard
        key={key}
        categoryId={id}
        product={product}/>
    } )
    
    products = <Card.Group itemsPerRow="4" doubling>{products}</Card.Group>*/
    const products = response.products || []
    
    // let {categories} = shop.store.categories
    let { size } = response
    let categoryTitle = ""
    if ( category && category.desc ) categoryTitle = category.desc.short_des
    
    let brandOptions = makeBrandOptions( category )
    let designOptions = makeDesignOptions( category )
    let filter = {
      currentPage: Number( query.page || 1 ),
      total: Number( size ) || 6,
      pageSize: Number( query.count || shop.config.pageSize ),
      brand: String( query.brand ),
      design: String( query.design ),
      brandOptions,
      designOptions,
      dir: String( query.dir || shop.config.standards.DIR ),
      sort: String( query.sort || shop.config.standards.SORT || "A-Z"),
      count: String( query.count || shop.config.standards.ITEMS_PER_PAGE )
    }
    
    let page = cmsStore.contentByCategory.get( this.current_id )

    const view = listview || query.view || shop.config.filter_defaults.view || "list"

    const currentSearch = queryString.stringify( {
      referrerTitle: category && category.title, referer: `${this.props.location.pathname}${this.props.location.search}`
    } )

    return (
      <div className={`CollectionPage ${category.cssClass} level-${category.level} parent-cat-${category.parent} ${category.title}`}>
        <SEOCategory category={category} seo={categoryPage}/>
        <MobileTitleBar>
          <CollectionPath categoryTitle={categoryTitle} path={path}/>
        </MobileTitleBar>
        <Container>
          {/*{category && <pre>{JSON.stringify( category.meta.submeta.fields.brand, null, 2 )}</pre>}*/}
          <MediaQuery minWidth={790}>
            <div>
              <div className="min-vh-100">
                <div className="db pv3">
                  <CollectionPath categoryTitle={categoryTitle} path={path}/>
                </div>
                <Grid columns="equal" stackable>
                  <Grid.Row>
                    
                    <MediaQuery minWidth={789}>
                      <Grid.Column width={3}>
                        <NavigationSidebar match={match} query={query}/>
                      </Grid.Column>
                    </MediaQuery>
                    
                    <Grid.Column>
                      <div className="mb3">
                        {page && <div className="pb2"><WordPress page={page}/></div>}
                        {showPagination && <div>
                          {/*FILTER LABEL*/}
                          {field && fieldValue && <div className="fl pt4 z-5 relative">
                            <Label as={"a"} onClick={this.removeFieldFilter}>
                              {`${translate( field )}: ${translate( fieldValue )}`}
                              <Icon name="close"/>
                            </Label>
                          </div>}
                          <Filter onChange={this.onChangeFilter}  {...filter} view={view} />
        
                        </div>}
                      </div>
                      
                      {shop.config.plugin[ "categoryShortcuts" ] &&
                        <CategoryShortcuts category={category} title={category.title}/>}
                      
                      {/*(ready && products.length !== 0) && <div>
                        <div className="fadeIn animate">
                          <section>
                            {products}
                          </section>
                        </div>
                        {/*Filter}
                        {showPagination &&
                          <div className="pt4">
                            <Filter showFilter={true}
                                    onChange={this.onChangeFilter} {...filter} view={view} />
                          </div>}
                      </div>*/}

                      {!loading && view === "grid" && <div key={this.props.location.pathname + this.props.location.search}
                                                   className="catalog-products pb4">
                    <Card.Group itemsPerRow={4} doubling>
                      {products.map( product => <ProductCard key={product.map_id} product={product}/> )}
                    </Card.Group>
                  </div>}
                      {!loading && view === "list" && <div key={this.props.location.pathname + this.props.location.search}
                      className="catalog-products catalog-products--list">
                      {products.map( ( product, index ) => <ProductListItem
                        index={index}
                        key={product.map_id}
                        product={product}
                        search={currentSearch}/> )}
                        </div>}
                      {ready && products.length === 0 && <div>
                        Keine Produkte gefunden
                      </div>}
                      
                      {!ready && <div>
                        <Button size="huge" basic loading fluid/>
                      </div>}
                    
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </div>
          </MediaQuery>
          <MediaQuery maxWidth={790}>
            <Row className="pt4 items-start">
              <Col xs="1" sm="1" md="1">
                <Filter onlyPagination={true} onChange={this.onChangeFilter}  {...filter} />
                {page && <WordPress page={page}/>}
                {shop.config.plugin[ "categoryShortcuts" ] &&
                  <CategoryShortcuts category={category} title={category.title}/>}
                
                {(ready && products.length !== 0) && <div>
                  <div className="fadeIn animate">
                    <section>
                      {products}
                    </section>
                  </div>
                  
                  {showSortBar &&
                    <div className="FilterBar animate fadeInUp fixed bg-white pa3 bottom-0 left-0 right-0 tc ">
                      <div>
                        <Button floated="right" icon="close" color="black" circular onClick={this.toggleSortBar}/>
                      </div>
                      <Filter hidePagination={true} onChange={this.onChangeFilter} {...filter} />
                    </div>}
                  
                  {showFilterBar &&
                    <div className="FilterBar animate fadeInUp fixed bg-white pa3 bottom-0 left-0 right-0 tc ">
                      <div>
                        <Button floated="right" icon="close" color="black" circular onClick={this.toggleFilterBar}/>
                      
                      </div>
                      <Filter hidePagination={true} onChange={this.onChangeFilter} {...filter} />
                    </div>}
                  
                  {!showAnyBar &&
                    <div className="fixed bottom-1 left-0 right-0 tc animate fadeInUp">
                      {/*<Button onClick={this.toggleFilterBar} size="small" circular color="black"><Icon name="filter" /> Filter</Button>*/}
                      <Button onClick={this.toggleSortBar} size="small" circular color="black"><Icon
                        name="sort"/> Sortieren</Button>
                    </div>}
                  
                  
                  <div className="pt4">
                    <Filter onlyPagination={true} onChange={this.onChangeFilter}  {...filter} />
                  </div>
                  
                  {/*Filter*/}
                  {/* {showPagination &&
                   <div className="pt4 tc">
                   <Filter showFilter={true}
                   onChange={this.onChangeFilter} {...filter} />
                   </div>} */}
                </div>}
                {ready && products.length === 0 && <div>
                  Keine Produkte gefunden
                </div>}
              </Col>
            </Row>
          </MediaQuery>
        </Container>
      </div>
    
    )
  }
}

CollectionPage.propTypes = {
  params: PropTypes.object,
  filter: PropTypes.object,
  location: PropTypes.object
}

const makeBrandOptions = ( category ) => {
  let all = { label: "Alle Marken", value: false }
  if ( category &&
    category.meta &&
    category.meta.submeta &&
    category.meta.submeta.fields &&
    category.meta.submeta.fields.brand ) {
    let brandOptions = category.meta.submeta.fields.brand.map( brand => {
      return { value: brand, label: brand }
    } )
    brandOptions = _.orderBy( brandOptions, ["label"], ["asc"] )
    brandOptions.unshift( all )
    return brandOptions
  } else {
    return [all]
  }
}

const CollectionPath = ( { categoryTitle, path } ) => (
  <div className="">
    <Breadcrumb>
      <Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>
      <Breadcrumb.Divider/>
      {path.length > 1 &&
        <Breadcrumb.Section link as={Link} style={{ whiteSpace: "nowrap" }} to={path[ 0 ].link}
                            className="parent-title">{path[ 0 ].title}</Breadcrumb.Section>}
      {path.length > 1 && <Breadcrumb.Divider/>}
      <Breadcrumb.Section active style={{ whiteSpace: "nowrap" }}>{categoryTitle}</Breadcrumb.Section>
    </Breadcrumb>
  </div>
)

const makeDesignOptions = ( category ) => {
  let all = { label: "Alle Designer", value: false }
  if ( category &&
    category.meta &&
    category.meta.submeta &&
    category.meta.submeta.fields &&
    category.meta.submeta.fields.design ) {
    let designOptions = category.meta.submeta.fields.design.map( design => {
      return { value: design, label: design }
    } )
    designOptions = _.orderBy( designOptions, ["label"], ["asc"] )
    designOptions.unshift( all )
    return designOptions
  } else {
    return [all]
  }
}

const mapChildren = cat => {
  if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
  return cat.map_id
}

// function toPathCatgory(path, cat_id) {
//   let category = shop.categoriesById.get(cat_id)
//   if (cat_id &&
// category) {
//     path.push({
//       title: category.desc.short_des,
//       link:  "/collection/" + cat_id
//     })
//   }
// }



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/pages/CollectionPage.js